import { View } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { SpanElement } from "./span-viewModel"

export class SpanView extends FormBuilderComponentView<SpanElement>{
    GetViewUniqueId(): string {
        return "V-A33A19C1-08C1-4321-A846-76A11720D53F"
    }
    loadHtml(): string {
        let element = require('./span.html').default;
        let style = require('./span.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;

}
